import { render, staticRenderFns } from "./InputAmountTickets.vue?vue&type=template&id=2c0a380a&scoped=true&"
import script from "./InputAmountTickets.vue?vue&type=script&lang=js&"
export * from "./InputAmountTickets.vue?vue&type=script&lang=js&"
import style0 from "./InputAmountTickets.vue?vue&type=style&index=0&id=2c0a380a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a380a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
